module.exports = __webpack_public_path__ + "static/media/help-drag-to-fill.b1a3fabb.png";